/*
|--------------------------------------------------------------------------
| Utilities: Show More Link
|--------------------------------------------------------------------------
*/

/**
 * Show more or less items by clicking an link
 * 
 * https://jsfiddle.net/g8q7zr97/1/
 * @namespace
 *
 * @example data attributes
 * data-gh-show-more-link-loaded="false" data-gh-show-more-link-object='{"itemDOM":"article","maxCollapsed":3,"showMoreText":"Show more...","showLessText":"Show less..."}'
 */
__gh__webApp.utilities.showMoreLink = {
  "init": function(){
  	this.loadAllShowMoreLinks();
  },
  
   /**
    * Load all expand collapse widgets
    * @param {object} element - wrapper element that has the data attributes on it
    * @param {object} settings - gh-show-more-link-object
    * @param {numeric} settings.maxCollapsed - number of items that should show when collapsed
    * @param {string} itemDOM - selector for the items that will be hidden and shown
    * @param {string} [showMoreText=Show more...] - toggle button text for showing more items
    * @param {string} [showLessText=Show less...] - toggle button text for showing less items
    */
  "main": function(element,settings){
  	var thisObject 		= __gh__webApp.utilities.showMoreLink,
		maxCollapsed 	    = ("maxCollapsed" in settings) ? settings.maxCollapsed : 5,
		itemDOM			      = ("itemDOM" in settings) ? settings.itemDOM : null,
		showMoreText 	    = ("showMoreText" in settings) ? settings.showMoreText : "Show more...",
		showLessText 	    = ("showLessText" in settings) ? settings.showLessText : "Show less...",
		index 		 	      = maxCollapsed-1,
		itemIndex	 	      = itemDOM+':gt('+index+')',
		$wrapper	 	      = $(element),
    $items            = $wrapper.find(itemDOM);
    totalItems        = $items.length;
    
    
    //Hide initial items
    if (totalItems > maxCollapsed) {
      injectToggleButton();
      hideItems();
    }
   
    

  	//Add the toggle button to the page
    function injectToggleButton(){
      var wrapperTag	 = $wrapper[0].nodeName.toLowerCase(),
          toggleHTML	 = '<a class="show-more" href="#">'+showMoreText+'</a>';
      if (wrapperTag=='ul' || wrapperTag=='ol'){
      	toggleHTML = '<li>' + toggleHTML + '</li>';
      }
      $(element).append(toggleHTML);
    }
    
    //Show items on click
  	function showItems(){
  	  $toggleButton = $wrapper.find('a.show-more');
        $toggleButton.text(showLessText);
        $wrapper.find(itemIndex).show();
        $toggleButton.one('click', function(e){
  	      e.preventDefault();
  	      hideItems();
  	  });
    }
    
    //Hide items on click
    function hideItems(){
  	  $toggleButton = $wrapper.find('a.show-more');
        $toggleButton.text(showMoreText);
        $wrapper.find(itemIndex+':not(.show-more)').hide();
        $toggleButton.one('click', function(e){
  	      e.preventDefault();
  	      showItems();
  	  });
    }
  
  },
  
  
  /**
   * Load all list expander widgets
   */
  "loadAllShowMoreLinks": function(){
		var thisObject = __gh__webApp.utilities.showMoreLink;
		
		$("[data-gh-show-more-link-loaded=false]").each(function(){
			var	$this		= $(this),
				settings	= $this.attr("data-gh-show-more-link-object");
				settings 	= JSON.parse(settings);
				
			$this.attr("data-gh-show-more-link-loaded",true);
			thisObject.main(this,settings);
		});
	}
};